var map = {
	"./CHILD/back pocket bag height.png": "7a07",
	"./CHILD/back pocket entry length.png": "960a",
	"./CHILD/back pocket height.png": "99bc",
	"./CHILD/back rise.png": "4464",
	"./CHILD/bottom opening.png": "fac0",
	"./CHILD/crotch height.png": "7f43",
	"./CHILD/elastic length.png": "4b30",
	"./CHILD/elastic width.png": "c559",
	"./CHILD/eye quantity.png": "df63",
	"./CHILD/fly zipper length.png": "b97f",
	"./CHILD/front rise.png": "3550",
	"./CHILD/hook quantity.png": "f8ef",
	"./CHILD/inseam length.png": "7551",
	"./CHILD/knee.png": "4301",
	"./CHILD/low hips.png": "4237",
	"./CHILD/pants side seam length.png": "8f64",
	"./CHILD/pocket bag height.png": "e8c9",
	"./CHILD/pocket entry length.png": "4102",
	"./CHILD/pocket height.png": "e820",
	"./CHILD/side seam back pocket position.png": "8d42",
	"./CHILD/side seam pocket position.png": "4d53",
	"./CHILD/thigh.png": "78401",
	"./CHILD/waist.png": "118c",
	"./CHILD/waistband buttons quantity.png": "8e3c",
	"./CHILD/waistband length.png": "a82d",
	"./CHILD/waistband width.png": "2813",
	"./CHILD/waistline back pocket position.png": "12e4",
	"./CHILD/waistline pocket position.png": "20d4",
	"./FEMALE/collar_edges_length.png": "b6a0",
	"./FEMALE/dresses/across back.png": "c1ff",
	"./FEMALE/dresses/across chest.png": "af37",
	"./FEMALE/dresses/across front.png": "7db0",
	"./FEMALE/dresses/across shoulders.png": "7977",
	"./FEMALE/dresses/apex to apex.png": "48bb",
	"./FEMALE/dresses/armhole length back.png": "b40d",
	"./FEMALE/dresses/armhole length front.png": "c0da",
	"./FEMALE/dresses/back button diameter.png": "97bd",
	"./FEMALE/dresses/back buttons quantity.png": "8c65",
	"./FEMALE/dresses/back centered zipper length.png": "2cc0",
	"./FEMALE/dresses/back exposed 10mm zipper length.png": "4789",
	"./FEMALE/dresses/back exposed 7mm zipper length.png": "7fd7",
	"./FEMALE/dresses/back invisible zipper length.png": "2a50",
	"./FEMALE/dresses/back lapped zipper length.png": "96ba",
	"./FEMALE/dresses/back neck drop.png": "78c0",
	"./FEMALE/dresses/bow length.png": "1f52",
	"./FEMALE/dresses/bow tapered angle.png": "4bf0",
	"./FEMALE/dresses/bow tie collar width.png": "c401",
	"./FEMALE/dresses/bow width.png": "b3cb",
	"./FEMALE/dresses/bust dart to bust dart.png": "9758",
	"./FEMALE/dresses/button diameter.png": "6477",
	"./FEMALE/dresses/center back length from empire seam to hem.png": "e271",
	"./FEMALE/dresses/center back length from high waist to hem.png": "0eed",
	"./FEMALE/dresses/center back length from waist seam to hem.png": "4c63",
	"./FEMALE/dresses/center back length to empire seam.png": "6641",
	"./FEMALE/dresses/center back length to hem.png": "83e5",
	"./FEMALE/dresses/center back length to underbust.png": "bab0",
	"./FEMALE/dresses/center back length to waist seam.png": "bbb4",
	"./FEMALE/dresses/center front length from empire seam to hem.png": "e8b1",
	"./FEMALE/dresses/center front length from high waist to hem.png": "0e8c",
	"./FEMALE/dresses/center front length from waist seam to hem.png": "b137",
	"./FEMALE/dresses/center front length to empire seam.png": "9bcb",
	"./FEMALE/dresses/center front length to hem.png": "8a7c",
	"./FEMALE/dresses/center front length to underbust.png": "57f2",
	"./FEMALE/dresses/center front length to waist seam.png": "b231",
	"./FEMALE/dresses/collar button diameter.png": "2b94",
	"./FEMALE/dresses/collar buttons quantity.png": "6832",
	"./FEMALE/dresses/collar edges length.png": "da74",
	"./FEMALE/dresses/collar length.png": "7825",
	"./FEMALE/dresses/collar topline length.png": "dc6d",
	"./FEMALE/dresses/collar width.png": "c631",
	"./FEMALE/dresses/cuff button diameter.png": "82d3",
	"./FEMALE/dresses/cuff buttons quantity.png": "9082",
	"./FEMALE/dresses/dress side invisible zipper length.png": "09cb",
	"./FEMALE/dresses/empire seam.png": "3331",
	"./FEMALE/dresses/flap width.png": "fcbf",
	"./FEMALE/dresses/flat collar edges length.png": "1678",
	"./FEMALE/dresses/flat collar length.png": "1a9f",
	"./FEMALE/dresses/flat collar topline length.png": "28d1",
	"./FEMALE/dresses/flat collar width.png": "4c40",
	"./FEMALE/dresses/front buttons quantity.png": "b3ff",
	"./FEMALE/dresses/front concealed zipper length.png": "d293",
	"./FEMALE/dresses/front length from HPS to empire seam.png": "14fb",
	"./FEMALE/dresses/front length from HPS to hem.png": "e732",
	"./FEMALE/dresses/front length from HPS to underbust.png": "79ff",
	"./FEMALE/dresses/front length from HPS to waist seam.png": "530d",
	"./FEMALE/dresses/front neck drop.png": "9b86",
	"./FEMALE/dresses/gather ruffle.png": "68fa",
	"./FEMALE/dresses/gather sleeve opening.png": "102d",
	"./FEMALE/dresses/gather sleeve ruffle.png": "6ef4",
	"./FEMALE/dresses/hemline sweep.png": "93f6",
	"./FEMALE/dresses/hips.png": "d929",
	"./FEMALE/dresses/low hips.png": "403a",
	"./FEMALE/dresses/lower flounce length.png": "1649",
	"./FEMALE/dresses/neck opening.png": "b887",
	"./FEMALE/dresses/neckline length.png": "be54",
	"./FEMALE/dresses/placket length.png": "7104",
	"./FEMALE/dresses/pocket bag height.png": "deef",
	"./FEMALE/dresses/pocket entry length.png": "8f4d",
	"./FEMALE/dresses/pocket height.png": "7e8e",
	"./FEMALE/dresses/pocket width welt.png": "2d77",
	"./FEMALE/dresses/ruffle back width.png": "8b17",
	"./FEMALE/dresses/ruffle front width.png": "796d",
	"./FEMALE/dresses/ruffle length.png": "6941",
	"./FEMALE/dresses/shank button diameter.png": "12b7",
	"./FEMALE/dresses/shank buttons quantity.png": "2e39",
	"./FEMALE/dresses/shoulder width.png": "8910",
	"./FEMALE/dresses/side invisible zipper length.png": "0504",
	"./FEMALE/dresses/side seam pocket position.png": "90ee",
	"./FEMALE/dresses/side seam.png": "8a8c",
	"./FEMALE/dresses/skirt side seam.png": "8440",
	"./FEMALE/dresses/skirt waist.png": "e9e9",
	"./FEMALE/dresses/sleeve cap length.png": "a26b",
	"./FEMALE/dresses/sleeve cuff length.png": "17dd",
	"./FEMALE/dresses/sleeve cuff width.png": "51c0",
	"./FEMALE/dresses/sleeve flounce length.png": "d297",
	"./FEMALE/dresses/sleeve flounce opening.png": "ba5b",
	"./FEMALE/dresses/sleeve length.png": "fbd0",
	"./FEMALE/dresses/sleeve lower flounce opening.png": "56fd",
	"./FEMALE/dresses/sleeve opening.png": "54af",
	"./FEMALE/dresses/sleeve ruffle length.png": "f866",
	"./FEMALE/dresses/sleeve ruffle width.png": "835a",
	"./FEMALE/dresses/sleeve upper arm width.png": "1f0e",
	"./FEMALE/dresses/sleeve upper flounce length.png": "4219",
	"./FEMALE/dresses/stand height.png": "65c9",
	"./FEMALE/dresses/strap length.png": "36d5",
	"./FEMALE/dresses/strap width.png": "0843",
	"./FEMALE/dresses/top side seam.png": "9142",
	"./FEMALE/dresses/underbust.png": "bb43",
	"./FEMALE/dresses/upper ruffle length.png": "7f5d",
	"./FEMALE/dresses/waist.png": "53fd",
	"./FEMALE/dresses/waistband length.png": "e52f",
	"./FEMALE/dresses/waistband width.png": "b913",
	"./FEMALE/dresses/waistline pocket position.png": "388e",
	"./FEMALE/jumpsuits/across back.png": "dbcc",
	"./FEMALE/jumpsuits/across chest.png": "342e",
	"./FEMALE/jumpsuits/across front.png": "019b",
	"./FEMALE/jumpsuits/across shoulders.png": "6653",
	"./FEMALE/jumpsuits/apex to apex.png": "3def",
	"./FEMALE/jumpsuits/armhole length back.png": "6177",
	"./FEMALE/jumpsuits/armhole length front.png": "93ca",
	"./FEMALE/jumpsuits/back neck drop.png": "6be8",
	"./FEMALE/jumpsuits/back rise.png": "1e59",
	"./FEMALE/jumpsuits/bottom opening.png": "f9e1",
	"./FEMALE/jumpsuits/bust dart to bust dart.png": "3e87",
	"./FEMALE/jumpsuits/center back length to waist.png": "9f0e",
	"./FEMALE/jumpsuits/center front length to waist.png": "f4f4",
	"./FEMALE/jumpsuits/crotch height.png": "3adb",
	"./FEMALE/jumpsuits/cuff button diameter.png": "54b2",
	"./FEMALE/jumpsuits/cuff buttons quantity.png": "a907",
	"./FEMALE/jumpsuits/cuff length.png": "2492",
	"./FEMALE/jumpsuits/cuff width.png": "66d3",
	"./FEMALE/jumpsuits/front length from HPS to waist.png": "3cb8",
	"./FEMALE/jumpsuits/front neck drop.png": "3d60",
	"./FEMALE/jumpsuits/front rise.png": "3e7c",
	"./FEMALE/jumpsuits/gather sleeve opening.png": "0b4f",
	"./FEMALE/jumpsuits/gather sleeve ruffle.png": "0fdf",
	"./FEMALE/jumpsuits/inseam length.png": "c797",
	"./FEMALE/jumpsuits/jumpsuit front centered zipper length.png": "4b66",
	"./FEMALE/jumpsuits/jumpsuit side invisible zipper length.png": "8653",
	"./FEMALE/jumpsuits/knee.png": "c3b0",
	"./FEMALE/jumpsuits/low hips.png": "cad3",
	"./FEMALE/jumpsuits/lower flounce length.png": "6f0f",
	"./FEMALE/jumpsuits/neck opening.png": "2d23",
	"./FEMALE/jumpsuits/neckline length.png": "43b2",
	"./FEMALE/jumpsuits/pants side seam length.png": "cf7c",
	"./FEMALE/jumpsuits/pleat depth.png": "aa02",
	"./FEMALE/jumpsuits/pocket bag height.png": "df21",
	"./FEMALE/jumpsuits/pocket side seam.png": "f22a",
	"./FEMALE/jumpsuits/pocket waist seam.png": "0693",
	"./FEMALE/jumpsuits/shoulder width.png": "8d7d",
	"./FEMALE/jumpsuits/sleeve back armhole length.png": "b7e2",
	"./FEMALE/jumpsuits/sleeve cap length.png": "7641",
	"./FEMALE/jumpsuits/sleeve flounce length.png": "4e13",
	"./FEMALE/jumpsuits/sleeve flounce opening.png": "33c4",
	"./FEMALE/jumpsuits/sleeve front armhole length.png": "7d90",
	"./FEMALE/jumpsuits/sleeve length.png": "9346",
	"./FEMALE/jumpsuits/sleeve lower flounce opening.png": "7bb2",
	"./FEMALE/jumpsuits/sleeve opening.png": "7b67",
	"./FEMALE/jumpsuits/sleeve ruffle length.png": "fca6",
	"./FEMALE/jumpsuits/sleeve ruffle width.png": "58f3",
	"./FEMALE/jumpsuits/sleeve upper arm width.png": "7840",
	"./FEMALE/jumpsuits/sleeve upper flounce length.png": "b7e5",
	"./FEMALE/jumpsuits/strap length.png": "24d4",
	"./FEMALE/jumpsuits/strap width.png": "5f07",
	"./FEMALE/jumpsuits/thigh.png": "4f53",
	"./FEMALE/jumpsuits/top side seam.png": "258c",
	"./FEMALE/jumpsuits/waistband length.png": "34a2",
	"./FEMALE/jumpsuits/waistband width.png": "3abd",
	"./FEMALE/pants/Side slit length.png": "cbf6",
	"./FEMALE/pants/back invisible zipper length.png": "4fda",
	"./FEMALE/pants/back pocket bag height.png": "2a3b",
	"./FEMALE/pants/back pocket entry length.png": "a681",
	"./FEMALE/pants/back pocket flap width.png": "5c8b",
	"./FEMALE/pants/back pocket height.png": "7b18a",
	"./FEMALE/pants/back pocket width welt.png": "6d33",
	"./FEMALE/pants/back rise.png": "c56c",
	"./FEMALE/pants/bottom opening.png": "e3f6",
	"./FEMALE/pants/crotch height.png": "8dd4",
	"./FEMALE/pants/cuff elastic length.png": "ea91",
	"./FEMALE/pants/cuff elastic width.png": "f86c",
	"./FEMALE/pants/flap width.png": "fcd0",
	"./FEMALE/pants/fly zipper length.png": "b5f9",
	"./FEMALE/pants/front rise.png": "bf92",
	"./FEMALE/pants/inseam length.png": "654c",
	"./FEMALE/pants/knee.png": "aee2",
	"./FEMALE/pants/low hips.png": "d88d",
	"./FEMALE/pants/pants side seam length.png": "c0dc",
	"./FEMALE/pants/pleat depth.png": "11fb",
	"./FEMALE/pants/pocket bag height.png": "22b5",
	"./FEMALE/pants/pocket entry length.png": "cd4f",
	"./FEMALE/pants/pocket height.png": "6584",
	"./FEMALE/pants/pocket width welt.png": "53ec",
	"./FEMALE/pants/side length.png": "251d",
	"./FEMALE/pants/side seam back pocket position.png": "5772",
	"./FEMALE/pants/side seam pocket position.png": "6009",
	"./FEMALE/pants/thigh.png": "3209",
	"./FEMALE/pants/waist.png": "aeed",
	"./FEMALE/pants/waistband button diameter.png": "7778",
	"./FEMALE/pants/waistband buttons quantity.png": "375d",
	"./FEMALE/pants/waistband elastic length.png": "6be5",
	"./FEMALE/pants/waistband elastic width.png": "a98e",
	"./FEMALE/pants/waistband partly elastic length.png": "0a73",
	"./FEMALE/pants/waistband partly elastic width.png": "6488",
	"./FEMALE/pants/waistband width.png": "23aa",
	"./FEMALE/pants/waistline back pocket position.png": "9098",
	"./FEMALE/pants/waistline pocket position.png": "1177",
	"./FEMALE/pocket width welt.png": "2d6e",
	"./FEMALE/side seam pocket position.png": "767b",
	"./FEMALE/skirts/back buttons quantity.png": "d31d",
	"./FEMALE/skirts/back centered zipper length.png": "600e",
	"./FEMALE/skirts/back exposed zipper length.png": "8c36",
	"./FEMALE/skirts/back invisible zipper length.png": "ad8d",
	"./FEMALE/skirts/back kick pleat length.png": "c5df",
	"./FEMALE/skirts/back lapped zipper length.png": "f005",
	"./FEMALE/skirts/back vent length.png": "202a",
	"./FEMALE/skirts/button diameter.png": "12a7",
	"./FEMALE/skirts/center back length from waist to hem.png": "5b43",
	"./FEMALE/skirts/center front length from waist to hem.png": "b0d2",
	"./FEMALE/skirts/flap width.png": "42c8",
	"./FEMALE/skirts/fly zipper length.png": "7348",
	"./FEMALE/skirts/gather ruffle.png": "f837",
	"./FEMALE/skirts/half skirt pleats.png": "c68f",
	"./FEMALE/skirts/hemline sweep.png": "0e51",
	"./FEMALE/skirts/low hips.png": "e086",
	"./FEMALE/skirts/pleat bottom width.png": "5858",
	"./FEMALE/skirts/pleat depth hipline.png": "aed5",
	"./FEMALE/skirts/pocket bag height.png": "d7ad",
	"./FEMALE/skirts/pocket entry length.png": "0201",
	"./FEMALE/skirts/pocket height.png": "0c68",
	"./FEMALE/skirts/pocket side seam.png": "32e5",
	"./FEMALE/skirts/pocket waist seam.png": "317d",
	"./FEMALE/skirts/pocket width welt.png": "2aac",
	"./FEMALE/skirts/ruffle length.png": "0078",
	"./FEMALE/skirts/side invisible zipper length.png": "d5c1",
	"./FEMALE/skirts/side seam pocket position.png": "3e05",
	"./FEMALE/skirts/side seam.png": "9d70",
	"./FEMALE/skirts/skirt side seam.png": "03e9",
	"./FEMALE/skirts/upper ruffle length.png": "93aa",
	"./FEMALE/skirts/waist.png": "5376",
	"./FEMALE/skirts/waistband button diameter.png": "08ea",
	"./FEMALE/skirts/waistband buttons quantity.png": "b2ab",
	"./FEMALE/skirts/waistband length.png": "23fe",
	"./FEMALE/skirts/waistband width.png": "2c5e",
	"./FEMALE/skirts/waistline pocket position.png": "6e28",
	"./FEMALE/tops/across back.png": "1dea",
	"./FEMALE/tops/across chest.png": "82ec",
	"./FEMALE/tops/across front.png": "8541",
	"./FEMALE/tops/across shoulders.png": "569a",
	"./FEMALE/tops/apex to apex.png": "307e",
	"./FEMALE/tops/armhole length back.png": "6630",
	"./FEMALE/tops/armhole length front.png": "f349",
	"./FEMALE/tops/back buttons quantity.png": "f940",
	"./FEMALE/tops/back centered zipper length.png": "c659",
	"./FEMALE/tops/back exposed 10mm zipper length.png": "78dd",
	"./FEMALE/tops/back exposed 7mm zipper length.png": "8fd6",
	"./FEMALE/tops/back invisible zipper length.png": "16d7",
	"./FEMALE/tops/back lapped zipper length.png": "646a",
	"./FEMALE/tops/back neck drop.png": "48b0",
	"./FEMALE/tops/bow length.png": "c3aa",
	"./FEMALE/tops/bow tapered angle.png": "6043",
	"./FEMALE/tops/bow tie collar width.png": "b24f",
	"./FEMALE/tops/bow width.png": "79ad",
	"./FEMALE/tops/bust dart to bust dart.png": "f9f9",
	"./FEMALE/tops/button diameter.png": "b2dd",
	"./FEMALE/tops/center back length to hem.png": "8b84",
	"./FEMALE/tops/center front length to hem.png": "de87",
	"./FEMALE/tops/collar button diameter.png": "134b",
	"./FEMALE/tops/collar buttons quantity.png": "ffb2",
	"./FEMALE/tops/collar edges length.png": "e36d",
	"./FEMALE/tops/collar height.png": "295e3",
	"./FEMALE/tops/collar length.png": "a5e9",
	"./FEMALE/tops/collar width.png": "8705",
	"./FEMALE/tops/cuff button diameter.png": "9079",
	"./FEMALE/tops/cuff buttons quantity.png": "9d30",
	"./FEMALE/tops/cuff length.png": "9109",
	"./FEMALE/tops/cuff width.png": "8973",
	"./FEMALE/tops/flat collar edges length.png": "e9f6",
	"./FEMALE/tops/flat collar length.png": "f32d",
	"./FEMALE/tops/flat collar topline length.png": "a0eb",
	"./FEMALE/tops/flat collar width.png": "a020",
	"./FEMALE/tops/front buttons quantity.png": "0544",
	"./FEMALE/tops/front concealed zipper length.png": "6eaf",
	"./FEMALE/tops/front length from HPS to hem.png": "075a",
	"./FEMALE/tops/front neck drop.png": "a134",
	"./FEMALE/tops/gather ruffle.png": "0492",
	"./FEMALE/tops/gather sleeve opening.png": "b503",
	"./FEMALE/tops/gather sleeve ruffle.png": "8f1b",
	"./FEMALE/tops/hemline sweep.png": "d032",
	"./FEMALE/tops/last button to hem placket.png": "6f14",
	"./FEMALE/tops/lower flounce length.png": "5310",
	"./FEMALE/tops/neck opening.png": "dc3b",
	"./FEMALE/tops/neckline length.png": "61d9",
	"./FEMALE/tops/placket length.png": "f41a",
	"./FEMALE/tops/placket width.png": "fe64",
	"./FEMALE/tops/ruffle back width.png": "69cf",
	"./FEMALE/tops/ruffle front width.png": "0610",
	"./FEMALE/tops/ruffle length.png": "f612",
	"./FEMALE/tops/shoulder width.png": "0873",
	"./FEMALE/tops/side invisible zipper length.png": "dde0",
	"./FEMALE/tops/side seam.png": "6c82",
	"./FEMALE/tops/sleeve cap length.png": "4527",
	"./FEMALE/tops/sleeve cuff length.png": "bcde",
	"./FEMALE/tops/sleeve flounce length.png": "8b5d",
	"./FEMALE/tops/sleeve flounce opening.png": "f179",
	"./FEMALE/tops/sleeve length.png": "f2da",
	"./FEMALE/tops/sleeve lower flounce opening.png": "c411",
	"./FEMALE/tops/sleeve opening.png": "3e9c",
	"./FEMALE/tops/sleeve ruffle length.png": "0a19",
	"./FEMALE/tops/sleeve ruffle width.png": "d65d",
	"./FEMALE/tops/sleeve upper arm width.png": "849c",
	"./FEMALE/tops/sleeve upper flounce length.png": "f502",
	"./FEMALE/tops/stand height.png": "5f01",
	"./FEMALE/tops/strap length.png": "6bb6",
	"./FEMALE/tops/strap width.png": "d66b",
	"./FEMALE/tops/upper ruffle length.png": "e175",
	"./FEMALE/tops/waist.png": "e466",
	"./FEMALE/waistline pocket position.png": "5eb7",
	"./FEMALE/сollar_topline_length.png": "4e9f",
	"./MALE/back pocket entry length.png": "9df8",
	"./MALE/back rise.png": "dce0",
	"./MALE/crotch height.png": "3fdc",
	"./MALE/elastic length.png": "293f",
	"./MALE/elastic width.png": "3cc2",
	"./MALE/eye quantity.png": "e7cc",
	"./MALE/fly zipper length.png": "e5b4",
	"./MALE/front rise.png": "e01f",
	"./MALE/hook quantity.png": "3a2b",
	"./MALE/inseam length.png": "e5da",
	"./MALE/knee.png": "d8cd",
	"./MALE/low hips.png": "4e8c",
	"./MALE/pants side seam length.png": "d674",
	"./MALE/pocket bag height.png": "f8e8",
	"./MALE/pocket button diameter.png": "6e5e",
	"./MALE/pocket buttons quantity.png": "a528",
	"./MALE/pocket entry length.png": "4972",
	"./MALE/pocket entry.png": "2c5e6",
	"./MALE/pocket flap width.png": "b327",
	"./MALE/pocket height.png": "c748",
	"./MALE/thigh.png": "b28c",
	"./MALE/waist.png": "1b1d",
	"./MALE/waistband buttons quantity.png": "c9d7",
	"./MALE/waistband length.png": "6b48",
	"./MALE/waistband width.png": "b677",
	"./pants/back invisible zipper length pants.png": "5cfb",
	"./pants/back pocket entry length.png": "1603",
	"./pants/back rise.png": "78c9",
	"./pants/bottom opening.png": "432e",
	"./pants/bust dart to bust dart jumpsuit.png": "f259",
	"./pants/button diameter.png": "7418",
	"./pants/crotch height.png": "59c1",
	"./pants/cuff elastic length.png": "9b4c",
	"./pants/cuff elastic width.png": "943c",
	"./pants/elastic length.png": "886b",
	"./pants/elastic width.png": "87fd",
	"./pants/eye quantity.png": "df70",
	"./pants/flap width.png": "e3c1",
	"./pants/fly zipper length.png": "c3cc",
	"./pants/front rise.png": "a08a",
	"./pants/hips.png": "ea90",
	"./pants/hook quantity.png": "48b1",
	"./pants/inseam length.png": "18e1",
	"./pants/knee.png": "6ae5",
	"./pants/low hips.png": "b813",
	"./pants/pants side seam length.png": "c91b",
	"./pants/pleat depth pants.png": "f25b",
	"./pants/pocket flap width.png": "b598",
	"./pants/pocket side seam.png": "b1fa",
	"./pants/pocket waist seam.png": "ab47",
	"./pants/side exposed 10mm zipper length.png": "fb01",
	"./pants/side invisible zipper length.png": "a674",
	"./pants/side seam pocket position.png": "98e3",
	"./pants/thigh.png": "01e6",
	"./pants/waist.png": "f060",
	"./pants/waistband button diameter.png": "9746",
	"./pants/waistband buttons quantity.png": "b7b2",
	"./pants/waistband elastic length.png": "fa0f",
	"./pants/waistband elastic width.png": "bf1e",
	"./pants/waistband length.png": "8507",
	"./pants/waistband partly elastic length.png": "1f2d",
	"./pants/waistband partly elastic width.png": "09d9",
	"./pants/waistband width.png": "704e",
	"./pants/waistline pocket position.png": "1dea3",
	"./shirts/across back.png": "2abc",
	"./shirts/across chest.png": "9975",
	"./shirts/across front.png": "2222",
	"./shirts/across shoulders.png": "ae0a",
	"./shirts/armhole back.png": "dfad",
	"./shirts/armhole front.png": "dd4d",
	"./shirts/armhole yoke.png": "d868",
	"./shirts/bow length.png": "166c",
	"./shirts/bow tapered angle.png": "3fdcf",
	"./shirts/button diameter.png": "c0f7",
	"./shirts/center back length to hem.png": "fba5",
	"./shirts/center front length to hem.png": "92bb",
	"./shirts/collar bow width.png": "413f",
	"./shirts/collar button diameter.png": "b8ca",
	"./shirts/collar buttons quantity.png": "c936",
	"./shirts/collar edges length peter pen or flat 17=1.png": "c4df",
	"./shirts/collar edges length.png": "1a1a",
	"./shirts/collar length.png": "aa3e",
	"./shirts/collar topline length peter pen or flat 17=1.png": "cdd04",
	"./shirts/collar width.png": "0530",
	"./shirts/cuff button diameter.png": "0747",
	"./shirts/cuff buttons quantity.png": "65d4",
	"./shirts/cuff length.png": "be42",
	"./shirts/cuff width.png": "a26f",
	"./shirts/decor button diameter.png": "d503",
	"./shirts/decor buttons quantity.png": "ee1b",
	"./shirts/front buttons quantity.png": "c165",
	"./shirts/front exposed 10mm zipper length.png": "e0f3",
	"./shirts/front length from hps to hem.png": "fa06",
	"./shirts/front neck drop.png": "9c19",
	"./shirts/hemline sweep.png": "c3f7",
	"./shirts/neck opening.png": "03f7",
	"./shirts/neckline length.png": "adcc",
	"./shirts/placket width.png": "ee4e",
	"./shirts/shoulder width.png": "95b4",
	"./shirts/side seam.png": "ba6f",
	"./shirts/sleeve cap back.png": "444e",
	"./shirts/sleeve cap front.png": "fbc6",
	"./shirts/sleeve cap length.png": "e0db",
	"./shirts/sleeve cap yoke.png": "c4a8",
	"./shirts/sleeve length.png": "b178",
	"./shirts/sleeve opening.png": "42e8",
	"./shirts/sleeve placket width.png": "e5ec",
	"./shirts/sleeve upper arm width.png": "f58d",
	"./shirts/stand height.png": "a18b",
	"./shirts/stand length.png": "b00e",
	"./shirts/waist.png": "caff",
	"./skirts/back kick pleat length.png": "c850",
	"./skirts/back vent length.png": "f95b",
	"./skirts/half skirt pleats.png": "5e1b",
	"./skirts/pleat bottom width.png": "55a7",
	"./skirts/pleat depth hipline.png": "6c51",
	"./sweatshirts/across shoulder.png": "eb34",
	"./sweatshirts/armhole length back.png": "a4c4",
	"./sweatshirts/armhole length front.png": "5c40",
	"./sweatshirts/back neck drop.png": "2127",
	"./sweatshirts/center back length.png": "b4cb",
	"./sweatshirts/center front length.png": "b55a",
	"./sweatshirts/front centered zipper length.png": "5141",
	"./sweatshirts/front exposed 10mm zipper length.png": "67c9",
	"./sweatshirts/front neck drop.png": "cc86",
	"./sweatshirts/hemline sweep.png": "5f5c",
	"./sweatshirts/hood depth.png": "6561",
	"./sweatshirts/hood edges length.png": "533c",
	"./sweatshirts/hood height.png": "7b71",
	"./sweatshirts/hood length.png": "6b3d",
	"./sweatshirts/hood neckline length.png": "dfdf",
	"./sweatshirts/neck opening.png": "2539",
	"./sweatshirts/neckline length.png": "d3ac",
	"./sweatshirts/shoulder width.png": "8409",
	"./sweatshirts/side seam.png": "086c",
	"./sweatshirts/sleeve armhole back.png": "07f0",
	"./sweatshirts/sleeve armhole front.png": "51b8",
	"./sweatshirts/sleeve binding length.png": "333f",
	"./sweatshirts/sleeve binding width.png": "3667",
	"./sweatshirts/sleeve cap back.png": "9abb",
	"./sweatshirts/sleeve cap front.png": "8338",
	"./sweatshirts/sleeve cap length.png": "1799",
	"./sweatshirts/sleeve cuff length.png": "35a2",
	"./sweatshirts/sleeve cuff width.png": "c24d",
	"./sweatshirts/sleeve length.png": "c6b3",
	"./sweatshirts/sleeve opening.png": "dbb7",
	"./sweatshirts/sleeve upper arm width.png": "daa5",
	"./sweatshirts/waistband length.png": "cea4",
	"./sweatshirts/waistband width.png": "91c7",
	"./tank_tops/across shoulder.png": "c640",
	"./tank_tops/armhole binding width.png": "d010",
	"./tank_tops/armhole length back.png": "86f2",
	"./tank_tops/armhole length front.png": "7959",
	"./tank_tops/center back length.png": "0ecb",
	"./tank_tops/center front length.png": "d017",
	"./tank_tops/hood depth.png": "d968",
	"./tank_tops/hood edges length.png": "eb7a",
	"./tank_tops/hood height.png": "b56a",
	"./tank_tops/hood length.png": "13ce",
	"./tank_tops/hood neckline length.png": "0c17",
	"./tank_tops/neckline binding width.png": "e184",
	"./tank_tops/neckline length.png": "a704",
	"./tank_tops/shoulder width.png": "a56d",
	"./tank_tops/side seam.png": "5598",
	"./tank_tops/top binding width.png": "8539",
	"./tshirts/across back.png": "be8c",
	"./tshirts/across shoulders.png": "484b",
	"./tshirts/armhole back.png": "bedb",
	"./tshirts/armhole front.png": "9a1a",
	"./tshirts/button diameter.png": "293e",
	"./tshirts/center back length.png": "da0d",
	"./tshirts/center front length.png": "363a",
	"./tshirts/collar button diameter.png": "cd3c",
	"./tshirts/collar buttons quantity.png": "9a83",
	"./tshirts/collar edges length.png": "8f79",
	"./tshirts/collar length.png": "c257",
	"./tshirts/collar width.png": "7bef",
	"./tshirts/front buttons quantity.png": "b189",
	"./tshirts/front exposed 10mm zipper length.png": "63a7",
	"./tshirts/front neck drop.png": "2054",
	"./tshirts/hood depth.png": "b7c1",
	"./tshirts/hood edges length.png": "2661",
	"./tshirts/hood height.png": "195e",
	"./tshirts/hood length.png": "ec86",
	"./tshirts/hood neckline length.png": "821e",
	"./tshirts/hps to hem.png": "6833",
	"./tshirts/neck opening.png": "691e",
	"./tshirts/neckline binding width.png": "7b02",
	"./tshirts/neckline enclosed binding width.png": "f8b6",
	"./tshirts/neckline length.png": "8a8e",
	"./tshirts/placket length.png": "4472",
	"./tshirts/placket width.png": "e726",
	"./tshirts/shoulder width.png": "2cad",
	"./tshirts/side seam.png": "f7b7",
	"./tshirts/sleeve binding length.png": "a38c",
	"./tshirts/sleeve binding width.png": "1a88",
	"./tshirts/sleeve cap back.png": "340b",
	"./tshirts/sleeve cap front.png": "0599",
	"./tshirts/sleeve cap length.png": "4a6d",
	"./tshirts/sleeve cuff lenght.png": "4462",
	"./tshirts/sleeve cuff width.png": "4939",
	"./tshirts/sleeve length.png": "dd56",
	"./tshirts/sleeve opening.png": "a1f7",
	"./tshirts/sleeve upper arm width.png": "e1df",
	"./tshirts/stand height.png": "2ecf",
	"./tshirts/stand length.png": "b2cb",
	"./tshirts/top binding width.png": "705a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "84ac";